// Resend env vars are read lazily here — `sendMail()` enforces presence at
// call time so the app can boot locally without email being configured.

export const RESEND_API_KEY: string | undefined =
  process.env.RESEND_API_KEY?.trim() || undefined;

// Default `From` header. Must be an address on a domain verified in Resend
// (e.g. `noreply@mail.loyaboost.com`).
export const RESEND_FROM_EMAIL: string | undefined =
  process.env.RESEND_FROM_EMAIL?.trim() || undefined;

// Optional display name prefixed before the From-address. If unset, Resend
// just shows the bare email.
export const RESEND_FROM_NAME: string | undefined =
  process.env.RESEND_FROM_NAME?.trim() || undefined;
